import Link from "@iso/components/Link/Link";
import IntlMessages from "@iso/components/utility/intlMessages";
import { Button, Form, Input, Modal, Checkbox } from "antd";
import React, { useEffect, useState } from "react";
import ReactPasswordChecklist from "react-password-checklist";
import SignUpStyleWrapper, { IFrame, IFrameContainer } from "./SignUp.styles";
import { SidePanel } from "../../../components/SidePanel/SidePanel";
import { Navbar } from "../../../components/Navbar/Navbar";
import { useAuth } from "../../../contexts/auth";
import { useNavigate, useSearchParams } from "react-router-dom";
import { createNotification } from "../../../components";
import { validateInvite } from "../../../services/account/api";
import { useIntl } from "react-intl";

function SignUp() {
  const { Register } = useAuth();

  const intl = useIntl();
  const [form] = Form.useForm();

  const values = Form.useWatch([], form);

  useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
  }, [form, values]);

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const invite = searchParams.get("invite");

  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [disabled, setDisable] = useState(false);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [passwordConfirmation, setPasswordConfirmation] = useState({
    value: "",
  });
  const [termsAccepted, setTerms] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [isPasswordValid, setPasswordValid] = useState(false);

  const comparePasswords = (value) => {
    if (value === password) {
      return {
        validateStatus: "success",
        errorMsg: null,
      };
    }
    return {
      validateStatus: "error",
      errorMsg: "The passwords doesn't match!",
    };
  };

  const handlePasswordDiff = (value) => {
    setPasswordConfirmation({ ...comparePasswords(value), value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    const data = {
      name: `${name} ${lastName}`,
      email,
      company,
      password,
      invite,
    };

    Register(data)
      .then((signed) => {
        if (signed) {
          return navigate("/");
        } else {
          return navigate(`/confirm-email/${email}`);
        }
      })
      .catch((err) => {
        createNotification("error", err.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (invite) {
      validateInvite(invite)
        .then((res) => {
          setCompany(res.company);
          setEmail(res.email);
          setDisable(true);
        })
        .catch((err) => {
          createNotification(
            "error",
            intl.formatMessage({ id: "page.register.validate.invite" }),
          );
        });
    }
  }, []);

  const showPasswordList = () => {
    if (password !== passwordConfirmation.value) {
      return true;
    }
    if (!password) {
      return false;
    }
    return !!(password && !isPasswordValid);
  };

  function isFormValid() {
    return (
      name &&
      lastName &&
      email &&
      company &&
      password &&
      termsAccepted &&
      isPasswordValid
    );
  }

  return (
    <>
      <Navbar />
      <IFrameContainer>
        <Modal
          title="TERMS OF USE"
          open={isModalOpen}
          footer={null}
          width={860}
          style={{ maxHeight: "823px", overflowY: "hidden" }}
          onCancel={handleCancel}
        >
          <IFrame
            frameborder="0"
            height="600px"
            width="100%"
            src="https://docs.google.com/document/d/e/2PACX-1vSpDPxMKV3Y8BWidLsAqk0fqAfYitX2cirIPUDTgmrjcPsGR7XJCYoDCgIdnPogfowO7FDL-0ICg9IB/pub?embedded=true"
          />
        </Modal>
      </IFrameContainer>

      <SignUpStyleWrapper className="isoSignUpPage">
        <div className="isoSignUpContentWrapper">
          <div className="isoSignUpContent">
            <h3 className="text-xl">
              <IntlMessages id="page.signUpTitle" />
            </h3>
            <Form onSubmit={handleSubmit} form={form} layout="vertical">
              <Form.Item
                style={{
                  display: "inline-block",
                  width: "calc(50% - 8px)",
                }}
                label="First Name"
                rules={[
                  {
                    required: true,
                    message: "Please input your first name!",
                  },
                ]}
              >
                <Input
                  placeholder="Enter your first name"
                  onChange={(e) => setName(e.target.value)}
                  size="large"
                />
              </Form.Item>
              <Form.Item
                style={{
                  display: "inline-block",
                  width: "calc(50% - 8px)",
                  margin: "0 8px",
                }}
                rules={[
                  {
                    required: true,
                    message: "Please input your last name!",
                  },
                ]}
                label="Last Name"
              >
                <Input
                  required
                  placeholder="Enter your last name"
                  onChange={(e) => setLastName(e.target.value)}
                  size="large"
                />
              </Form.Item>
              <Form.Item label="Company">
                <Input
                  value={company}
                  disabled={disabled}
                  placeholder="Enter the company name"
                  onChange={(e) => setCompany(e.target.value)}
                  size="large"
                />
              </Form.Item>
              <Form.Item
                label="E-mail"
                rules={[
                  { required: true, message: "Please input your email!" },
                ]}
              >
                <Input
                  required
                  value={email}
                  disabled={disabled}
                  placeholder="saffe@saffe.com"
                  onChange={(e) => setEmail(e.target.value)}
                  size="large"
                />
              </Form.Item>
              <Form.Item
                label="Password"
                rules={[
                  { required: true, message: "Please type your password!" },
                ]}
              >
                <Input
                  success={isPasswordValid.toString()}
                  type="password"
                  placeholder="********"
                  onChange={(e) => setPassword(e.target.value)}
                  size="large"
                />
              </Form.Item>
              {showPasswordList() && (
                <ReactPasswordChecklist
                  rules={[
                    "minLength",
                    "specialChar",
                    "number",
                    "capital",
                    "lowercase",
                    "match",
                  ]}
                  messages={{
                    minLength: "At least 8 characters",
                    specialChar: "Contains a symbol",
                    number: "Contains a number",
                    capital: "At least 1 uppercase letter",
                    lowercase: "At least 1 lowercase letter",
                  }}
                  minLength={8}
                  value={password}
                  valueAgain={passwordConfirmation.value}
                  onChange={(isValid) => {
                    setPasswordValid(isValid);
                  }}
                  iconSize={10}
                  invalidColor="#E16408"
                  validColor="#00ABAB"
                />
              )}
              <Form.Item
                label="Confirm Password"
                validateStatus={passwordConfirmation.validateStatus}
                help={passwordConfirmation.errorMsg}
                rules={[
                  {
                    required: true,
                    message: "Please confirm your password!",
                  },
                ]}
              >
                <Input
                  success={isPasswordValid.toString()}
                  type="password"
                  placeholder="********"
                  value={passwordConfirmation.value}
                  onChange={(e) => handlePasswordDiff(e.target.value)}
                  size="large"
                />
              </Form.Item>
              <div className="isoInputWrapper" style={{ marginBottom: "30px" }}>
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: "You must accept our terms to continue.",
                    },
                  ]}
                >
                  <Checkbox onChange={(e) => setTerms(e.target.checked)}>
                    <IntlMessages id="page.signUpTermsConditions" />
                    <Link
                      onClick={showModal}
                      className="text-primary hover:text-primary cursor-pointer"
                    >
                      <IntlMessages id="page.signUpTermsConditionsCTA" />
                    </Link>
                  </Checkbox>
                </Form.Item>
              </div>
              <div className="flex justify-between items-center">
                <Link
                  to="/login"
                  className="text-primary hover:text-primary cursor-pointer"
                >
                  <IntlMessages id="page.signUpAlreadyAccount" />
                </Link>
                <Button
                  className="bg-primary border-0 text-white !px-12 shadow-none"
                  size="large"
                  htmlType="submit"
                  shape="round"
                  onClick={handleSubmit}
                  loading={loading}
                  disabled={!isFormValid()}
                  type="primary"
                >
                  <IntlMessages id="page.signUpButton" />
                </Button>
              </div>
            </Form>
          </div>
        </div>
        <SidePanel />
      </SignUpStyleWrapper>
    </>
  );
}

export default SignUp;
